import { PdCollapseGroup } from "./pd-collapse-group/PdCollapseGroup.js";
//#region src/pd-collapse-group/pd-collapse-group.ts
var tag = "pd-collapse-group";
if (!customElements.get(tag)) customElements.define(tag, PdCollapseGroup);
//#endregion
export { PdCollapseGroup };
